import { render, staticRenderFns } from "./ZeroState.vue?vue&type=template&id=2a8d6254&"
import script from "./ZeroState.vue?vue&type=script&lang=js&"
export * from "./ZeroState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports